export const extractBoolean = (data, term) => {
  const text = data.find(o => o.id === term);
  return text?.value === "1" ? true : false;
};
